/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bank': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M614.4 819.2V648.533a34.133 34.133 0 0168.267 0V819.2h68.266V512h-204.8v307.2H614.4zm-273.067 0V648.533a34.133 34.133 0 0168.267 0V819.2h68.267V512h-204.8v307.2h68.266zM819.2 512v307.2h34.133v68.267H170.667V819.2H204.8V512h-34.133c-31.266 0-46.08-38.57-22.836-59.494l341.334-307.2a34.133 34.133 0 0145.67 0l341.334 307.2c23.244 20.923 8.43 59.494-22.836 59.494H819.2zm-559.582-68.267h504.764L512 216.576 259.618 443.733z"/>'
  }
})
